import type { UIMessage } from "@ai-sdk/react";
import { MessageBubble } from "./MessageBubble";
import styles from "./MessageList.module.css";
import { ThinkingMessage } from "./ThinkingMessage";

interface MessageListProps {
	messages: UIMessage[];
	isLoading: boolean;
	isThinking?: boolean;
	userImage: string | null;
}

export function MessageList({
	messages,
	isLoading,
	isThinking = false,
	userImage,
}: MessageListProps) {
	// Don't show anything if no messages (greeting will be shown instead)
	if (messages.length === 0 && !isLoading) {
		return null;
	}

	// Show "Thinking..." when AI is processing (submitted) and last message is from user
	// Don't show during streaming - by then AI response is already appearing
	const showThinking =
		isThinking &&
		messages.length > 0 &&
		messages[messages.length - 1].role === "user";

	return (
		<div className={styles.container}>
			{messages.map((message) => (
				<MessageBubble
					key={message.id}
					message={message}
					userImage={userImage}
				/>
			))}

			{showThinking && <ThinkingMessage />}
		</div>
	);
}
